import { useState } from "react";
import { useParams } from "react-router-dom";

import { Anchor, Paper, Stack } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";
import {
  QuestionnaireTitle,
  QuestionnaireType,
} from "@/encounters/components/EncounterLabor/constants/labor-questionnaires";
import { EncounterLaborQuickButtonDrawer } from "@/encounters/components/EncounterLabor/EncounterLaborDrawer/EncounterLaborQuickButtonDrawer";
import { useBirthObservations } from "@/encounters/components/EncounterLabor/hooks/useBirthObservations";

export default function ShoulderDystociaDisplay() {
  const { clientId, encounterId } = useParams() as { clientId: string; encounterId: string };
  const [opened, setOpened] = useState(false);
  const { setOptimisticBirth, clearOptimisticBirth } = useBirthObservations(encounterId, clientId);

  const handleOpen = () => {
    setOpened(true);
  };

  const handleClose = () => {
    setOpened(false);
  };

  return (
    <>
      <Stack gap={8} align="flex-start" data-testid="shoulder-dystocia-stack">
        <TextWrapper size="sm" variant="bold">
          Shoulder Dystocia
        </TextWrapper>
        <Paper p="lg" h="auto" w="100%" bg="gray.0" data-testid="shoulder-dystocia-card">
          <TextWrapper size="sm" c="gray.9">
            Document shoulder dystocia emergency interventions and outcomes.
          </TextWrapper>
          <Anchor
            fw={600}
            type="button"
            c="burgundy.9"
            component="button"
            underline="always"
            onClick={handleOpen}
            data-testid="open-dystocia-panel-link"
          >
            Open Dystocia Panel
          </Anchor>
        </Paper>
      </Stack>
      <EncounterLaborQuickButtonDrawer
        opened={opened}
        clientId={clientId}
        onClose={handleClose}
        encounterId={encounterId}
        onBirthCreate={setOptimisticBirth}
        onClearOptimisticBirthDateTime={clearOptimisticBirth}
        questionnaireName={QuestionnaireType.ShoulderDystocia}
        questionnaireTitle={QuestionnaireTitle.ShoulderDystocia}
      />
    </>
  );
}
